export const FETCH_COUNTRIES = '/countries';
export const GET_USERS_LOCATION = '/location';
export const GET_COUNTRY_SUMMARY = 'donation/country/';
export const GET_SLIDER_STATE = '/getappstate';

export const getVaccinationsEndpoint =  ({ country}) => `https://corona.lmao.ninja/v3/covid-19/vaccine/coverage/countries/${country}?lastdays=1`